import React from 'react';
import {AsyncComponent} from "../../../core/components/router/async-component";

const LanguageMenuModuleAsyncComponent = AsyncComponent(async () => import('./language-menu-module' /* webpackChunkName: "language-menu.module" */ ));
  export const LanguageMenuModuleAsync = (props) => {
    return <React.Suspense fallback={<div/>}>
    <LanguageMenuModuleAsyncComponent {...props}/>
  </React.Suspense>
};
